import i18next from 'i18next';

import { CHECKLIST_TYPES } from '#constants/checklists';

i18next.addResources('en', 'Checklists', {
  newChecklist: 'Create new checklist',
  date: 'Date',
  operator: 'Operator',
  dateAM: 'Date AM',
  operatorAM: 'Operator AM',
  datePM: 'Date PM',
  operatorPM: 'Operator PM',
  edit: 'Edit',
  delete: 'Delete',
  [CHECKLIST_TYPES.DAILY_AM_STILLS]: 'Daily AM Stills',
  [CHECKLIST_TYPES.DAILY_PM_STILLS]: 'Daily PM Stills',
  [CHECKLIST_TYPES.DAILY_AM_MASH]: 'Daily AM Mash',
  [CHECKLIST_TYPES.DAILY_PM_MASH]: 'Daily PM Mash',
  [CHECKLIST_TYPES.WEEKLY_STILLS]: 'Weekly Stills',
  [CHECKLIST_TYPES.WEEKLY_MASH]: 'Weekly Mash'
});
